import { useEffect } from "react";

/**
 * CRM keyboard shortcuts (when focus is not in an input/textarea).
 * Ctrl/Cmd+K — search (handled separately)
 * N — new enquiry
 * B — board view
 * L — list view
 * ? — show help
 */
export function useCrmKeyboardShortcuts({
  onNewLead,
  onSearch,
  onBoardView,
  onListView,
  onShowHelp,
  enabled = true,
}) {
  useEffect(() => {
    if (!enabled) return;

    const isTypingTarget = (el) => {
      if (!el) return false;
      const tag = el.tagName;
      return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el.isContentEditable;
    };

    const onKeyDown = (e) => {
      if (isTypingTarget(document.activeElement)) return;
      if (e.metaKey || e.ctrlKey || e.altKey) {
        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
          e.preventDefault();
          onSearch?.();
        }
        return;
      }

      const key = e.key.toLowerCase();
      if (key === "n") {
        e.preventDefault();
        onNewLead?.();
      } else if (key === "b") {
        e.preventDefault();
        onBoardView?.();
      } else if (key === "l") {
        e.preventDefault();
        onListView?.();
      } else if (key === "?") {
        e.preventDefault();
        onShowHelp?.();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [enabled, onNewLead, onSearch, onBoardView, onListView, onShowHelp]);
}
